module.exports = __webpack_public_path__ + "images/japanese_grades_a042cac.png";